import CheckIcon from './CheckIcon';
import CloseIcon from './CloseIcon';
import CartIcon from './CartIcon';
import HeartOutlineIcon from './HeartOutlineIcon';
import UserIcon from './UserIcon';
import TickCircleIcon from './TickCircleIcon';
import CrossCircleIcon from './CrossCircleIcon';
import RedCheckIcon from './RedCheckIcon';
import MinusIcon from './MinusIcon';
import PlusIcon from './PlusIcon';
import FrameIcon from './FrameIcon';
import SpeakerIcon from './SpeakerIcon';
import MagnifyingGlassIcon from './MagnifyingGlassIcon';
import RadioCheckIcon from './RadioCheckIcon';
import RadioOutlineIcon from './RadioOutlineIcon';
import VerticalDotsIcon from './VerticalDotsIcon';
import VeganIcon from './VeganIcon';
import RichInIronIcon from './RichInIronIcon';
import GlutenFreeIcon from './GlutenFreeIcon';
import MagnesiumIcon from './MagnesiumIcon';
import SoyFreeIcon from './SoyFreeIcon';
import MenuIcon from './MenuIcon';
import ArrowIcon from './ArrowIcon';
import WhatsappIcon from './WhatsappIcon';
import MessageIcon from './MessageIcon';
import CallIcon from './CallIcon';
import ShippingHomeIcon from './ShippingHomeIcon';
import ShippingInStoreIcon from './ShippingInStoreIcon';
import ShippingExpressIcon from './ShippingExpressIcon';
import ChevronDownIcon from './ChevronDownIcon';
import ChevronRightIcon from './ChevronRightIcon';
import CalendarIcon from './CalendarIcon';
import ShareIcon from './ShareIcon';
import SuccessTickCircleIcon from './SuccessTickCircleIcon';
import FilterIcon from './FilterIcon';
import SortIcon from './SortIcon';
import AboutCutleryCoverIcon from './AboutCutleryCoverIcon';
import AboutCutleryIcon from './AboutCutleryIcon';
import AboutFoodIcon from './AboutFoodIcon';
import AboutLeavesIcon from './AboutLeavesIcon';
import ProcessingCircleIcon from './ProcessingCircleIcon';
import ForwardArrowIcon from './ForwardArrowIcon';
import MasterClassIcon from './MasterClassIcon';
import PersonalShopperIcon from './PersonalShopperIcon';
import CopyIcon from './CopyIcon';
import StoriesPlayIcon from './StoriesPlayIcon';
import MailIcon from './MailIcon';
import VegIcon from './VegIcon';
import NonVegIcon from './NonVegIcon';
import ChefHatIcon from './ChefHatIcon';
import KitchenEquipmentIcon from './KitchenEquipmentIcon';
import VideoCameraIcon from './VideoCameraIcon';
import ScreenSizeIcon from './ScreenSizeIcon';
import EditIcon from './EditIcon';
import ClockIcon from './ClockIcon';
import LocationPinIcon from './LocationPinIcon';
import MessageTickCircleIcon from './MessageTickCircleIcon';
import EmailCircleIcon from './EmailCircleIcon';
import PhoneCircleIcon from './PhoneCircleIcon';
import WhatsAppCircleIcon from './WhatsAppCircleIcon';
import WhatsappShareIcon from './WhatsappShareIcon';
import TrashIcon from './TrashIcon';
import CrossCircle from './CrossCircle';
import VideoPlayIcon from './VideoPlayIcon';
import GiftingHomepageTickerIcon from './GiftingHomepageTickerIcon';
import WhatsappBagTickerIcon from './WhatsappBagTickerIcon';

export {
  CheckIcon,
  CloseIcon,
  HeartOutlineIcon,
  CartIcon,
  UserIcon,
  TickCircleIcon,
  CrossCircleIcon,
  RedCheckIcon,
  MinusIcon,
  PlusIcon,
  FrameIcon,
  SpeakerIcon,
  MagnifyingGlassIcon,
  RadioCheckIcon,
  RadioOutlineIcon,
  VerticalDotsIcon,
  VeganIcon,
  RichInIronIcon,
  SoyFreeIcon,
  MenuIcon,
  ArrowIcon,
  WhatsappIcon,
  MessageIcon,
  CallIcon,
  MagnesiumIcon,
  GlutenFreeIcon,
  ShippingHomeIcon,
  ShippingExpressIcon,
  ShippingInStoreIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  CalendarIcon,
  ShareIcon,
  SuccessTickCircleIcon,
  FilterIcon,
  SortIcon,
  AboutCutleryCoverIcon,
  AboutCutleryIcon,
  AboutFoodIcon,
  AboutLeavesIcon,
  ProcessingCircleIcon,
  ForwardArrowIcon,
  MasterClassIcon,
  PersonalShopperIcon,
  CopyIcon,
  StoriesPlayIcon,
  MailIcon,
  VegIcon,
  NonVegIcon,
  ChefHatIcon,
  KitchenEquipmentIcon,
  VideoCameraIcon,
  ScreenSizeIcon,
  EditIcon,
  ClockIcon,
  LocationPinIcon,
  MessageTickCircleIcon,
  EmailCircleIcon,
  PhoneCircleIcon,
  WhatsAppCircleIcon,
  WhatsappShareIcon,
  TrashIcon,
  CrossCircle,
  VideoPlayIcon,
  GiftingHomepageTickerIcon,
  WhatsappBagTickerIcon,
};
